/*!
Copyright (C) 2022 Liberty Infrasystems. All rights reserved.
*/

async function sleep(millis) {
    return new Promise((resolve) => {
        setTimeout(() => { resolve(true); }, millis);
    });
}

export {
    sleep,
};
